import React, { useState } from "react";
import PropTypes from "prop-types";
import cs from "classnames";
import classes from "./QuestionTextArea.module.scss";

const QuestionTextArea = ({
  id,
  label,
  value,
  onChange,
  placeholder = "Long Answer text",
  error,
  required = false,
  rows = 3,
}) => {
  const [isFocused, setIsFocused] = useState(false);

  const onBlur = () => {
    setIsFocused(false);
  };

  const onFocus = () => {
    setIsFocused(true);
  };

  return (
    <div className={cs(classes.container, { [classes.error]: error })}>
      <label htmlFor={id} className={cs(classes.label)}>
        {label}
        {required && <span className={cs(classes.required)}> *</span>}
      </label>
      <div className={cs(classes.textareaWrapper)}>
        <textarea
          id={id}
          className={cs(classes.textarea, {
            [classes.focused]: isFocused,
          })}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          onFocus={onFocus}
          placeholder={placeholder}
          rows={rows}
          style={{ "--rows": rows }}
        />

        <div className={cs(classes.underlineLines)}>
          {Array.from({ length: rows }).map((_, index) => (
            <div key={index} className={cs(classes.underline)} />
          ))}
        </div>
      </div>
      {error && <div className={cs(classes.errorMessage)}>{error}</div>}
    </div>
  );
};

QuestionTextArea.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.node.isRequired, // Allow JSX
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  error: PropTypes.string,
  required: PropTypes.bool,
  rows: PropTypes.number,
};

export default QuestionTextArea;

